import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=542b50fe&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b50fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542b50fe')) {
      api.createRecord('542b50fe', component.options)
    } else {
      api.reload('542b50fe', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=542b50fe&scoped=true&", function () {
      api.rerender('542b50fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29cgV3S3TVR0o/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports